import SrTraceTrack from "./index.vue";

SrTraceTrack.install = function(Vue) {
  Vue.component(SrTraceTrack.name, SrTraceTrack);
};

export default SrTraceTrack;



// WEBPACK FOOTER //
// ./packages/SrTraceTrack/index.js